export default "__VITE_ASSET__DF9KRXDM__"